<div class="wrapper">
  <div class="header">
    <div class="maintitle">Contribute as much as you can</div>
    <div class="subtitle">Fundraisers that couldn’t raise money</div>
  </div>
  <div class="divideline"></div>
  <div class="storytiles" *ngFor="let item of infolist">
    <div class="tile">
      <div class="tileinfo">
        <div class="timeleft">
          <em class="material-icons">schedule</em>
          <span>{{(item?.end_date | dayjs:'diffInDays') + ' Days ' }} {{item?.end_date | difftime}} hours left</span>
        </div>
        <div class="storytitle">{{item?.title}}</div>
        <div class="moneyshort"  *ngIf="amtRemainig(item?.raised?.raised,item?.amount_requested)"><strong><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{amtRemainig(item?.raised?.raised,item?.amount_requested) | inrFormat}}</strong> remaining</div>
        <div class="progress">
          <app-progress-bar [amount]="item?.raised?.raised" [goal]="item?.amount_requested"></app-progress-bar>
        </div>
      </div>
      <div class="tileimg">
        <img loading="lazy" [attr.data-src]="item?.story_widget?.cdn_path" alt="">
        <div class="dntbtn">
          <button *ngIf="!selected.includes(item.id)" class="btn" (click)="val = hide(item.id)">
            <em class="material-icons">add</em>
            Donate
          </button>
        </div>
        <div class="incrementbtn" *ngIf="selected.includes(item.id)">
          <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
            <em class="material-icons">remove</em>
          </button>
          <div><app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon>{{amt[item.id].amount}}</div>
          <button class="minus" (click)="amtchanger('plus', item.id)" [ngClass]="{'max': amt[item.id].amount === minamount[currency].minamt * 10}" mat-ripple>
            <em class="material-icons">add</em>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="submitbtn" [ngClass]="{'active':active}">
    <button (click)="submit()" mat-button [disabled]="config?.isOrderLoading ? true : false">
      <span *ngIf="!config?.isOrderLoading">{{btnlabel}}</span>
    <div *ngIf="config?.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </button>
  </div>
</div>